import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { CurvaAbcVendaTableComponent } from './curva-abc-venda-table.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CurvaAbcVendaTableComponent
    ],
    exports: [
        CurvaAbcVendaTableComponent
    ]
})
export class CurvaAbcVendaTableModule {}
